module.exports = __webpack_public_path__ + "static/media/m-1-07.822aa236.svg";